<app-header></app-header>

<section class="container-xxl">
    <!-- BREADCRUMB AREA - STARTS -->
    <div class="breadcrumb-area">
        <nav aria-label="breadcrumb mb-0">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a class="screen-reader" routerLink="/" [attr.title]="language=='English'?'Home':'होम'">{{ 'Home' | translate }}</a></li>
                <li class="breadcrumb-item"><a class="screen-reader" routerLink="/employeecorner" [attr.title]="language=='English'?'Employee Corner':'कर्मचारी कॉर्नर'">{{ 'EmployeeCorner' | translate }}</a></li>
                <li class="breadcrumb-item"><a class="active-nemu screen-reader">{{htmldecode(bdtitle)}}</a></li>
            </ol>
        </nav>
    </div>
    <!-- BREADCRUMB AREA - ENDS -->

    <div class="inner-page">
        <div class="inner-page-details">
            <div class="row">

                <div class="col-lg-12">
                    <!-- INNER CONTENT - STARTS -->
                    <div class="inner-page-sidedetails">
                        <div class="row">
                            <div class="col-lg-12">
                                <div id="section-New"></div>
                                <div class="inner-banner-image">
                                    <div class="image-area">
                                        <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
                                    </div>
                                </div>
                                <div class="details">
                                    <div class="title">
                                        <h2 class="screen-reader" id="employee-table">{{ title_type_ }}</h2>
                                    </div>
                                    <div class="description">
                                        <div class="annual-report">
                                            <div class="row">
                                                <div class="col-lg-12">



                    <!-- search section -->
                    <div class="searchpanel notific-frm">
                        <form [formGroup]="searchForm" (ngSubmit)="searchTender()">
                            <div class="row">
                                <div class="col-xl-3 col-md-3 col-sm-3 col-xs-3">
                                    <div class="form-group font-adjust">
                                        <label class="mb-2 mt-2 screen-reader"> <b>{{ 'Keyword' | translate }}</b>
                                        </label>
                                        <input type="text" autocomplete="off"
                                            class="form-control screen-reader"
                                            placeholder="{{ 'Keyword' | translate }}" name="title"
                                            id="title" formControlName="title">
                                    </div>
                                </div>
                                <div
                                    class="col-xl-1 col-md-12 col-sm-6 col-xs-12 d-flex align-items-end">
                                    <div class="d-flex align-items-center gap-3 mt-3">
                                        <button type="submit" [attr.title]="language=='English'?'Search':'खोजें'"
                                            class="btn btn-outline-success screen-reader"
                                           >{{'Search'|translate}}
                                        </button>
                                        <div *ngIf="RefreshBtn">
                                            <button type="button" [attr.title]="language=='English'?'Refresh':'रीफ़्रेश करें'"
                                                class="btn btn-outline-secondary py-0-2 screen-reader"
                                                (click)="RefreshPage()">
                                                <i class="bi bi-arrow-repeat fs-5" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </div>
                    <!-- search section -->
                                                    <!-- Employee Corner area -->


                    <div class="calender-main text-center">
                        <div class="row">


                            <div class="table-responsive font-adjust">
                                <table class="table table-bordered" aria-describedby="employee-table"> <!-- Document Details Table -->
                                    <thead>
                                        <tr>
                                            <th class="screen-reader">#{{'Slno'|translate}}</th>
                                            <th class="text-start screen-reader">{{ 'DocumentName' | translate }}</th>
                                            <th class="screen-reader">{{ 'DocumentSize_' | translate }}</th>
                                            <th class="screen-reader">{{ 'Download' | translate }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let i = index;let item of fileDetails | paginate: { id:'pg1',itemsPerPage: limit, currentPage: currentPage,totalItems: totalRecords};">

                                            <td class="screen-reader" *ngIf="currentPage==1">{{i+1}}</td>
                                            <td class="screen-reader" *ngIf="currentPage>1">{{(limit*(currentPage-1)) + (i+1)}}</td>
                                            <td class="text-start screen-reader">
                                                {{(language=='English') ? htmldecode(item.DOC_TITLE) : htmldecode(item.DOC_TITLE_HN)}}
                                            </td>
                                            <td class="screen-reader">
                                                <span *ngIf="item.file_exists">
                                                    {{item.DOC_Details.fileSize }}
                                                    <span style="text-transform: uppercase;" *ngIf="checkFileType(item)!==false" [innerHtml]="checkFileType(item).file"></span>
                                                        {{item.dtmCreatedOn | date:'MMM d, y'}}
                                                </span>
                                            </td>
                                            <td class="screen-reader">
                                                <a *ngIf="item.file_exists"
                                                [attr.href]="backend_url+'storage/app/uploads/'+item.DOC_NAME"
                                                target="_blank"
                                                [attr.download]="item.DOC_NAME"
                                                [attr.title]="language=='English'?item.DOC_TITLE:item.DOC_TITLE_HN"
                                                class="bi bi-download me-1 text-success"></a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                           

                            <p *ngIf="fileDetails.length==0" class="screen-reader font-adjust" [style.text-align]="'center'"><b>{{ "Norecordsfound" | translate }}</b></p>

                        </div>
                     
                        <pagination-controls id="pg1" class="text-center screen-reader" (pageChange)="pageChanged($event)"
                        *ngIf="totalRecords > 20" ></pagination-controls>
                    </div>

                                                    <!-- Employee Corner area -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- INNER CONTENT - ENDS -->
                </div>
            </div>
        </div>
    </div>

</section>

<app-clients></app-clients>

<app-footer></app-footer>